import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { Flex, Input, Typography, Select, TimePicker } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { trainSchedAction } from "src/store/Slices/Administrator/TrainSchedSlice";
import { getTrainers } from "src/store/Slices/DropDownSlice";
import dayjs from "dayjs";

const AddEditTrainSchedModal = ({
  visible,
  setVisible,
  trainSchedInfo,
  setPage,
  setPageSize,
}) => {
  const dispatch = useDispatch();

  const [dayWeek, setDayWeek] = useState();
  const [trainer, setTrainer] = useState();
  const [timeFrom, setTimeFrom] = useState();
  const [timeTo, setTimeTo] = useState();

  const trainers = useSelector((state) => state.DropDownSlice.trainersList);

  const daysOpt = [
    { label: "Понедельник", value: 1 },
    { label: "Вторник", value: 2 },
    { label: "Среда", value: 3 },
    { label: "Четверг", value: 4 },
    { label: "Пятница", value: 5 },
    { label: "Суббота", value: 6 },
    { label: "Воскресенье", value: 7 },
  ];

  useEffect(() => {
    setDayWeek();
    setTrainer();
    setTimeFrom();
    setTimeTo();
  }, [visible.flag]);

  useEffect(() => {
    if (visible.flag === "edit") {
      setTrainer(
        trainers?.data?.value.find((el) => el.label === trainSchedInfo?.employ)
          ?.value
      );
      setDayWeek(
        daysOpt.find((el) => el.label === trainSchedInfo?.dayOfWeek)?.value
      );
      setTimeFrom(trainSchedInfo?.timeFrom);
      setTimeTo(trainSchedInfo?.timeTo);
    }
  }, [visible, trainSchedInfo]);

  useEffect(() => {
    dispatch(getTrainers());
  }, [visible]);
  const onClickSubmit = () => {
    console.log(timeFrom, timeTo);
    dispatch(
      trainSchedAction({
        flag: visible.flag === "add" ? "put" : "post",
        value: {
          id: visible.flag !== "add" ? trainSchedInfo.id : undefined,
          employId: trainer,
          dayOfWeek: dayWeek,
          timeFrom: timeFrom ? timeFrom.add(3, "hour") : undefined,
          timeTo: timeTo ? timeTo.add(3, "hour") : undefined,
        },
      })
    ).then(() => {
      dispatch(trainSchedAction({ flag: "get" })).then(() => {
        setVisible({ open: false, flag: "" });
        setPage(1);
        setPageSize(20);
      });
    });
  };

  return (
    <CModal
      alignment="center"
      visible={visible.open}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setVisible({ open: false, flag: "" });
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {visible.flag === "add" ? "Добавить пакет" : "Редактировать пакет"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Тренер</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  visible.flag === "add" && dispatch(getTrainers());
                }}
                value={trainer}
                onChange={(e) => {
                  setTrainer(e);
                }}
                options={trainers?.data?.value}
              />
            </div>
            <div>
              <Typography.Title level={5}>День недели</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                value={dayWeek}
                onChange={(e) => {
                  setDayWeek(e);
                }}
                options={daysOpt}
              />
            </div>
            <div>
              <Typography.Title level={5}>Время работы от</Typography.Title>
              <TimePicker
                placeholder="Выбрать время"
                onChange={(date) => {
                  setTimeFrom(date); // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                value={timeFrom ? dayjs(timeFrom, "HH:mm") : undefined}
                style={{
                  marginBottom: 8,
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>До</Typography.Title>
              <TimePicker
                placeholder="Выбрать время"
                onChange={(date) => {
                  setTimeTo(date); // wrap in array
                  // confirm();
                }}
                onPressEnter={() => confirm()}
                value={timeTo ? dayjs(timeTo, "HH:mm") : undefined}
                style={{
                  marginBottom: 8,
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible({ open: false, flag: "" });
          }}
          className="text-light"
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className="text-light">
          {visible.flag === "add" ? "Добавить" : "Редактировать"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddEditTrainSchedModal;
